import { render, staticRenderFns } from "./car-slider3.vue?vue&type=template&id=78e5b664&"
import script from "./car-slider3.vue?vue&type=script&lang=js&"
export * from "./car-slider3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonFavorite: require('/var/www/components/button/button-favorite.vue').default,PictureComponent: require('/var/www/components/picture/picture-component.vue').default,CatalogItemHoverSliderMobile: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-hover-slider-mobile.vue').default})
